<i18n>
{
  "cl": {
    "applyButton": "Aplicar",
    "thanksButton": "Ok, gracias",
    "cancelButton": "Cancelar"
  },
  "pe": {
    "applyButton": "Aplicar",
    "thanksButton": "Ok, gracias",
    "cancelButton": "Cancelar"
  },
  "br": {
    "applyButton": "Aplicar",
    "thanksButton": "Ok, obrigado",
    "cancelButton": "Cancelar"
  }
}
</i18n>
<template>
  <div>
    <div class="message-item">
      <div class="message-item-inner p-3 my-1">
        <header>
          <div>
            <div class="is-flex is-justify-content-space-between is-align-items-center">
              <div class="is-flex is-align-items-center">
                <div class="is-flex is-flex-direction-column">
                  <div>
                    <div class="is-flex is-align-items-center">
                      <p class="has-text-weight-medium is-size-6">Custo pré-pago</p>
                    </div>
                  </div>
                </div>
              </div>
              <div>
                <b-button
                  class="toggleButton is-rounded ml-2"
                  size="is-small"
                  aria-controls="param-2"
                  :aria-expanded="isOpen2"
                  @click="isOpen2 = !isOpen2">
                  <i :class="{ 'fa-angle-down': !isOpen2, 'fa-angle-up': isOpen2}" class="fas" aria-hidden="true" />
                </b-button>
              </div>
            </div>
          </div>
        </header>
        <b-collapse :open="isOpen2" aria-id="param-2" class="message-body is-size-7" animation="slide">
          <div class="content mt-3 p-4">
            <div v-if="(operation.remaining?.prepaidFee && isPrepaidDateValid) || isUpdateNewDate" class="mb-0 is-flex">
              <div class="prepaid-column">
                <div v-if="isUpdateNewDate">
                  <b-skeleton class="ml-1" width="60%" :animated="animated" />
                  <b-skeleton class="ml-1" width="60%" :animated="animated" />
                  <b-skeleton class="ml-1" width="60%" :animated="animated" />
                  <b-skeleton class="ml-1" width="60%" :animated="animated" />
                  <b-skeleton class="ml-1" width="60%" :animated="animated" />
                  <b-skeleton class="ml-1" width="60%" :animated="animated" />
                  <b-skeleton class="ml-1" width="60%" :animated="animated" />
                </div>
                <div v-else>
                  <p>
                    Data:
                    <b-tag type="is-light is-primary" size="is-small" class="ml-1" rounded>{{ operation.remaining?.prepaidDate }}</b-tag>
                  </p>
                  <p>
                    Valor da parcela pendente:
                    <b-tag type="is-light is-primary" size="is-small" class="ml-1" rounded>{{ formatAmount(operation.remaining?.remainingTotalPayments) }}</b-tag>
                  </p>
                  <p>
                    Saldo da última parcela:
                    <b-tag type="is-light is-primary" size="is-small" class="ml-1" rounded>{{ formatAmount(operation.remaining?.remainingBalance) }}</b-tag>
                  </p>
                  <p>
                    Proporção da última parcela:
                    <b-tag type="is-light is-primary" size="is-small" class="ml-1" rounded>{{ operation.remaining?.inflationProportional }}</b-tag>
                  </p>
                  <p>
                    IPCA proporcional:
                    <b-tag type="is-light is-primary" size="is-small" class="ml-1" rounded>{{ formatAmount(operation.remaining?.proportionalIpcaUpate) }}</b-tag>
                  </p>
                  <p>
                    Juros proporcionais:
                    <b-skeleton v-if="isUpdateNewDate" width="30%" :animated="animated" />
                    <b-tag type="is-light is-primary" size="is-small" class="ml-1" rounded>{{ formatAmount(operation.remaining?.proportionalInterestIUB) }}</b-tag>
                  </p>
                  <p>
                    Seguro total da próxima parcela:
                    <b-tag type="is-light is-primary" size="is-small" rounded>{{ formatAmount(operation.remaining?.totalInsurancesNextDebtPayment) }}</b-tag>
                  </p>
                </div>
              </div>
              <div class="prepaid-column">
                <div class="card-item shadowless">
                  <p class="has-text-weight-bold">
                    Custo pré-pago:<br>
                    <b-skeleton v-if="isUpdateNewDate" width="30%" :animated="animated" /><span v-else class="has-text-primary is-size-5">{{ formatAmount(operation.remaining?.prepaidFee) }}</span>
                  </p>
                </div>
              </div>
            </div>
            <div v-else-if="!isUpdateNewDate">
              <b-notification
                v-if="isPrepaidDateValid"
                class="my-1"
                type="is-danger is-light"
                data-cy="resume-company-operation-id"
                :closable="false">
                <i class="fa-solid fa-triangle-exclamation" /> O custo do pré-pagamento não pode ser demonstrado porque o valor do IPCA nesta data não está disponível.
              </b-notification>
              <b-notification
                v-if="!isPrepaidDateValid"
                class="my-1"
                type="is-danger is-light"
                data-cy="resume-company-operation-id"
                :closable="false">
                <i class="fa-solid fa-triangle-exclamation" /> O custo do pré-pagamento de uma data anterior não pode ser exibido.
              </b-notification>
            </div>
          </div>
        </b-collapse>
      </div>
    </div>
    <div class="message-item last-message">
      <div class="message-item-inner p-3 my-1">
        <header>
          <div>
            <div class="is-flex is-justify-content-space-between is-align-items-center">
              <div class="is-flex is-align-items-center">
                <div class="is-flex is-flex-direction-column">
                  <div>
                    <div class="is-flex is-align-items-center">
                      <p class="has-text-weight-medium is-size-6">Atualizar CAP</p>
                    </div>
                  </div>
                </div>
              </div>
              <div>
                <b-button
                  class="toggleButton is-rounded ml-2"
                  size="is-small"
                  aria-controls="param-1"
                  :aria-expanded="isOpen"
                  @click="isOpen = !isOpen">
                  <i :class="{ 'fa-angle-down': !isOpen, 'fa-angle-up': isOpen}" class="fas" aria-hidden="true" />
                </b-button>
              </div>
            </div>
          </div>
        </header>
        <b-collapse :open="isOpen" aria-id="notification" class="message-body is-size-7" animation="slide">
          <div class="content mt-3 p-4">
            <div class="mb-0">
              <div>
                <div v-if="!resultsView">
                  <div class="input-fields">
                    <b-field label="Parcela inicial" :type="fields.firstPayment.type" :message="fields.firstPayment.message">
                      <b-numberinput
                        id="input-first-payment"
                        v-model="fields.firstPayment.number"
                        :placeholder="minPaymentNumber"
                        step="1"
                        :min="minPaymentNumber"
                        :max="maxPaymentNumber"
                        controls-position="compact"
                        :expanded="false"
                        @input="verifyFields" />
                    </b-field>
                    <b-field label="Parcela final" :type="fields.lastPayment.type" :message="fields.lastPayment.message">
                      <b-numberinput
                        id="input-last-payment"
                        v-model="fields.lastPayment.number"
                        :placeholder="maxPaymentNumber"
                        step="1"
                        :min="minPaymentNumber"
                        :max="maxPaymentNumber"
                        controls-position="compact"
                        :expanded="false"
                        @input="verifyFields" />
                    </b-field>
                    <b-field label="CAP (%)" :type="fields.newInflationaryUpperBound.type" :message="fields.newInflationaryUpperBound.message">
                      <b-numberinput
                        id="input-upper-bound"
                        v-model="fields.newInflationaryUpperBound.number"
                        :placeholder="fields.newInflationaryUpperBound.number"
                        step="0.1"
                        min="0"
                        min-step="0.01"
                        icon-right="percentage"
                        controls-position="compact"
                        :expanded="false"
                        @input="verifyFields" />
                    </b-field>
                  </div>
                  <div class="buttons">
                    <button
                      id="apply-button"
                      class="button is-button-primary is-rounded"
                      :disabled="buttonIsDisabled"
                      @click="showConfirmModal()">
                      {{ $t('applyButton') }}
                    </button>
                    <button
                      id="cancel-button"
                      class="button is-button-primary-light is-rounded"
                      @click="cancelChanges">
                      {{ $t('cancelButton') }}
                    </button>
                  </div>
                </div>
                <div v-else>
                  <div v-if="changesResult.error">
                    <Message v-if="changesResult.message !== ''" :message="changesResult.message" :icon="changesResult.icon" :as-card="false" />
                  </div>
                  <div v-else>
                    <h5>Resultados</h5>
                    <div class="changes-details-header">
                      <p>N</p>
                      <p>CAP</p>
                      <p>BOLETO</p>
                    </div>
                    <div v-for="payment in changesResult.result" :key="payment.paymentNumber" class="changes-details">
                      <p>{{ payment.paymentNumber }}</p>
                      <b-tooltip
                        v-if="payment.previousInflationaryUpperBound !== payment.newInflationaryUpperBound"
                        :label="`CAP antes de la modificación: ${(payment.previousInflationaryUpperBound*100).toFixed(2)}%`"
                        type="is-light"
                        position="is-top">
                        <p :id="`payment-${payment.paymentNumber}-newUpperBound`" class="had-changed">
                          {{ (payment.newInflationaryUpperBound*100).toFixed(2) }}%
                        </p>
                      </b-tooltip>
                      <b-tooltip
                        v-else
                        label="CAP no fue modificado"
                        type="is-light"
                        position="is-top">
                        <p :id="`payment-${payment.paymentNumber}-newUpperBound`" class="had-not-changed">
                          {{ (payment.newInflationaryUpperBound*100).toFixed(2) }}%
                        </p>
                      </b-tooltip>
                      <div>
                        <b-tooltip
                          v-if="payment.newBoletoCreated"
                          label="Se generó un nuevo boleto"
                          type="is-light"
                          position="is-top">
                          <i class="fa-solid fa-file-text had-changed" />
                        </b-tooltip>
                        <b-tooltip
                          v-else-if="payment.isPaid"
                          label="No se cambió la tasa ni se creó un nuevo boleto porque la cuota ya se encuentra pagada"
                          type="is-light"
                          position="is-top">
                          <i class="fa-solid fa-file had-not-changed" />
                        </b-tooltip>
                        <b-tooltip
                          v-else
                          :label="
                            payment.previousInflationaryUpperBound !== payment.newInflationaryUpperBound
                              ? 'Se cambió la tasa pero no se generó boleto porque la cuota aún no está disponible'
                              : 'No se requirió realizar cambios'"
                          type="is-light"
                          position="is-top">
                          <i class="fa-solid fa-file had-not-changed" />
                        </b-tooltip>
                      </div>
                    </div>
                  </div>
                  <button
                    id="thanks-button"
                    class="button is-button-primary is-rounded apply"
                    @click="finishChanges">
                    {{ $t('thanksButton') }}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </b-collapse>
      </div>
    </div>
    <OperationModifierConfirmModal
      :first-payment="fields.firstPayment.number"
      :last-payment="fields.lastPayment.number"
      :new-inflationary-upper-bound="fields.newInflationaryUpperBound.number"
      :is-component-modal-active="isComponentModalActive"
      @applyInflationaryUpperBoundChanges="applyInflationaryUpperBoundChanges"
      @cancelModal="cancelModal" />
  </div>
</template>

<script>
import Message from '@/ui/components/Message.vue';
import { setOperationPaymentsInflationaryUpperBound } from '@/application/services/api-clients/operations';
import { formatNumberByCountry } from '@/infrastructure/format';
import OperationModifierConfirmModal from './OperationModifierConfirmModal.vue';

export default {
  name: 'OperationModifier',
  components: {
    Message,
    OperationModifierConfirmModal
  },
  props: {
    operation: { type: Object },
    isUpdateNewDate: { type: Boolean, requiered: true, default: false }
  },
  data() {
    return {
      isOpen: false,
      isOpen2: false,
      today: new Date(new Date().setHours(0, 0, 0, 0)),
      fields: {
        firstPayment: {
          number: this.determineFirstPaymentNumber(),
          type: '',
          message: 'Parcela inicial correta (por padrão, próxima parcela a ser paga)'
        },
        lastPayment: {
          number: this.operation.termAsMonths,
          type: '',
          message: 'Parcela final correta (por padrão, toda a operação)'
        },
        // This value is stored as a percentage, but is converted to decimal
        // when using it as a parameter for the setOperationInflationary... service
        newInflationaryUpperBound: {
          number: this.determineDefaultInflationaryUpperBound(),
          type: '',
          message: 'CAP correto (por padrão, CAP da próxima parcela a pagar)'
        }
      },
      minPaymentNumber: this.determineFirstPaymentNumber(),
      maxPaymentNumber: this.operation.termAsMonths,
      changesResult: {
        error: false,
        errorMessage: '',
        result: [],
        icon: ''
      },
      resultsView: false,
      buttonIsDisabled: false,
      isComponentModalActive: false,
      messages: {
        firstPayment: {
          default: 'Parcela inicial correta (por padrão, próxima parcela a ser paga)',
          valid: 'Parcela inicial correta',
          errorOtherField: 'Parcela inicial maior que a final',
          errorOutOfBounds: 'Parcela inicial fora do intervalo permitido',
          errorInvalid: 'Parcela inicial inválida'
        },
        lastPayment: {
          default: 'Parcela final correta (por padrão, toda a operação)',
          valid: 'Parcela final correta',
          errorOtherField: 'Parcela final menor que a inicial',
          errorOutOfBounds: 'Parcela final fora do intervalo permitido',
          errorInvalid: 'Parcela final inválida'
        },
        newInflationaryUpperBound: {
          default: 'CAP correto (por padrão, CAP da próxima parcela a pagar)',
          valid: 'CAP correto',
          errorOtherField: 'CAP menor que 0',
          errorInvalid: 'CAP menor que 0'
        }
      }
    };
  },
  computed: {
    isPrepaidDateValid() {
      const prepaidDate = new Date(this.operation.remaining?.prepaidDate);
      prepaidDate.setHours(0, 0, 0, 0);
      prepaidDate.setDate(prepaidDate.getDate() + 1); // Agregas un día
      // eslint-disable-next-line no-console
      console.log('PREPAID', prepaidDate);
      return prepaidDate >= this.today;
    }
  },
  methods: {
    determineFirstPaymentNumber() {
      return this.operation.payments
        .filter(payment => !payment.isPaid)
        .reduce((earliestPaymentNumber, currentPayment) => (
          Math.min(earliestPaymentNumber, currentPayment.paymentNumber)
        ), this.operation.termAsMonths);
    },
    determineDefaultInflationaryUpperBound() {
      const nextPaymentNumber = this.determineFirstPaymentNumber();
      const nextPayment = this.operation.payments
        .find(payment => payment.paymentNumber === nextPaymentNumber);
      return nextPayment.inflationaryUpperBound * 100;
    },
    verifyFields() {
      const fields = ['firstPayment', 'lastPayment', 'newInflationaryUpperBound'];
      const fieldsAreValid = fields.map(field => {
        let errorType = '';
        const currentNumber = this.fields[field].number;
        // Verify firstPayment
        if (field === 'firstPayment') {
          if (currentNumber > this.fields.lastPayment.number) {
            errorType = 'errorOtherField';
          } else if (this.minPaymentNumber > currentNumber) {
            errorType = 'errorOutOfBounds';
          } else if (!Number.isInteger(currentNumber)) {
            errorType = 'errorInvalid';
          }
        // Verify lastPayment
        } else if (field === 'lastPayment') {
          if (this.fields.firstPayment.number > currentNumber) {
            errorType = 'errorOtherField';
          } else if (this.maxPaymentNumber < currentNumber) {
            errorType = 'errorOutOfBounds';
          } else if (!Number.isInteger(currentNumber)) {
            errorType = 'errorInvalid';
          }
        // Verify newInflationaryUpperBound
        } else if (currentNumber < 0) { // (field === 'newInflationaryUpperBound') {
          errorType = 'errorInvalid';
        }
        const valid = errorType === '';
        this.fields[field].message = valid
          ? this.messages[field].valid
          : this.messages[field][errorType];
        this.fields[field].type = valid
          ? ''
          : 'is-danger';
        return valid;
      });
      this.buttonIsDisabled = !fieldsAreValid.every(v => v === true);
    },
    showConfirmModal() {
      this.isComponentModalActive = true;
    },
    cancelModal() {
      this.isComponentModalActive = false;
    },
    async applyInflationaryUpperBoundChanges() {
      this.isComponentModalActive = false;
      try {
        this.changesResult.result = await setOperationPaymentsInflationaryUpperBound(
          this.operation._id,
          this.fields.firstPayment.number,
          this.fields.lastPayment.number,
          this.fields.newInflationaryUpperBound.number / 100
        );
      } catch (_error) {
        this.changesResult = {
          message: 'Ocorreu um erro durante a comunicação com o servidor',
          icon: 'data_maintenance.svg',
          error: true
        };
      }
      this.resultsView = true;
    },
    cancelChanges() {
      this.fields.firstPayment.number = this.determineFirstPaymentNumber();
      this.fields.lastPayment.number = this.operation.termAsMonths;
      this.fields.newInflationaryUpperBound.number = this.determineDefaultInflationaryUpperBound();
      Object.keys(this.fields).forEach(field => {
        this.fields[field].message = this.messages[field].default;
        this.fields[field].type = '';
      });
      this.changesResult = {
        error: false,
        errorMessage: '',
        result: []
      };
    },
    finishChanges() {
      this.fields.firstPayment.number = undefined;
      this.fields.lastPayment.number = undefined;
      this.fields.newInflationaryUpperBound.number = undefined;
      this.changesResult = {
        error: false,
        errorMessage: '',
        result: []
      };
      this.resultsView = false;
      this.$emit('cap-modification');
    },
    formatAmount(number) {
      const prefix = {
        br: 'R$ ',
        cl: 'UF ',
        pe: 'S/ '
      }[this.$i18n.locale];
      const formattedNumber = this.formatCurrency(number);
      return `${prefix}${formattedNumber}`;
    },
    formatCurrency(number) {
      const fractionDigits = {
        cl: ['MORTGAGE', 'PARKING'].includes(this.operation.type) ? 6 : 0,
        br: 2,
        pe: 2
      }[this.$i18n.locale];

      return formatNumberByCountry({
        number,
        countryIn: this.$i18n.locale,
        usePrefix: false,
        fractionDigits
      });
    }
  }
};
</script>

<style>
.message-item-inner:hover {
  background-color: #f8f8f8ad;
  border-radius: 10px;
}

.message-item {
  border-bottom: 0.1rem solid #f0f0f0;
}

.last-message {
  border: none;
}

.message-body {
  padding: 0;
  border: none;
}
.message-body .content-insurance {
  padding: 0;
  border: 0.2px solid #f0f0f0;
  border-radius: 0.5rem;
  background-color: #ffffffad;
}

.prepaid-column {
  width: 320px;
}

.method-title {
  margin: 1.5rem 0rem;
}
.input-fields {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(10rem, 10rem));
  gap: 1.5rem 3rem;
  margin: 1.5rem 0rem;
}
.changes-details, .changes-details-header {
  display: grid;
  grid-template-columns: 4rem 4rem 4rem;
  justify-items: center;
}
.changes-details-header p {
  font-weight: 600;
}
.had-changed {
  color: var(--primary);
}
.had-not-changed {
  color: var(--color-moon);
}
.button.apply {
  margin-top: 1.25rem;
}
</style>
